import { Component, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { ChangePasswordFormComponent } from '../../change-password-form/change-password-form.component';

@Component({
  selector: 'app-change-password-dialog',
  standalone: true,
  imports: [ChangePasswordFormComponent],
  template: `
    <app-change-password-form [username]="username" (changed)="dialogRef.close(true)" />
  `,
})
export class ChangePasswordDialogComponent {
  readonly dialogRef = inject(DynamicDialogRef);
  readonly username: string = inject(DynamicDialogConfig).data?.username ?? '';
}
